import { AnswerInput } from '__generatedTypes__/globalTypes'
import { findOneQuestion_findOneQuestion as Question } from '__generatedTypes__/findOneQuestion'

export type NumericResponseAnswer = {
  id?: string
  isFraction: boolean
  value?: number | string
  numeratorValue?: number | string
  denominatorValue?: number | string
}

export const EMPTY_NUMERIC_RESPONSE_ANSWER: NumericResponseAnswer = {
  isFraction: false,
  value: '',
  numeratorValue: '',
  denominatorValue: '',
}

export const parseNumericResponseAnswerHtml = (textAsHtml: string): NumericResponseAnswer => {
  try {
    const parsed = JSON.parse(textAsHtml) as Partial<NumericResponseAnswer>

    return {
      ...EMPTY_NUMERIC_RESPONSE_ANSWER,
      ...parsed,
      isFraction: !!parsed.isFraction,
    }
  } catch (error) {
    console.error('An error ocurred while trying to parse NumericResponse answer', error)
    return EMPTY_NUMERIC_RESPONSE_ANSWER
  }
}

export const convertAnswerToNumericResponseAnswer = (answer?: Question['answer']): NumericResponseAnswer => {
  const firstAnswer = answer?.[0]

  if (!firstAnswer) {
    return EMPTY_NUMERIC_RESPONSE_ANSWER
  }

  return {
    id: firstAnswer.id,
    ...parseNumericResponseAnswerHtml(firstAnswer.textAsHtml),
  }
}

export const serializeNumericResponseAnswer = (answer?: NumericResponseAnswer): AnswerInput[] => {
  if (!answer) {
    return []
  }

  const payload = answer.isFraction
    ? {
        isFraction: true,
        numeratorValue: Number(answer.numeratorValue),
        denominatorValue: Number(answer.denominatorValue),
      }
    : {
        isFraction: false,
        value: Number(answer.value),
      }

  return [
    {
      id: answer.id,
      textAsHtml: JSON.stringify(payload),
      isCorrect: true,
      point: 1,
      order: 0,
    },
  ]
}
